import React from 'react';
import ModalFooter from "components/BaseModalComponents/Footer/ModalFooter";
import BasedModal, {IProps} from '../BaseModalComponents/BasedModal';
import {
    Container,
    ModalBody, ModalDescription, ModalTitle,
} from "./areYouSureModalStyles";

const bodyStyle = {
    paddingTop: 15,
    fontSize: 20,
    fontWeight: 'bold',
    alignItems: 'center'
}

const style = {
    justifyContent: 'space-evenly'
}

function AreYouSureModal({isOpen, title,description, onRequestClose, onApplyClick} : IProps) {
    return (
        <BasedModal
            isOpen={isOpen}
            onRequestClose={onRequestClose}
        >
            <Container id="modal_confirm">
                <ModalBody style={bodyStyle as object}>
                    <ModalTitle>{title}</ModalTitle>
                    {description && <ModalDescription>{description}</ModalDescription>}
                </ModalBody>
                <ModalFooter
                    onCancelClick={onRequestClose}
                    onApplyClick={onApplyClick}
                    style={style}
                    applyText="Да"
                    cancelText="Нет"
                />
            </Container>
        </BasedModal>
    );
}

export default AreYouSureModal;
